import React from 'react';
import './index.css';
import logoSrc from './img/logo.png';
import LazyLoad from 'react-lazyload'; // Import LazyLoad

function Outsourcing() {
  return (
    <>
      {/* Hero Section */}
      <div className="banner-logo" id="sectionBanner1">
        {logoSrc && <img src={logoSrc} alt="Shigjeta Logo" />}
      </div>
      <section className="banner-section" id="sectionBanner">
        <div className="banner-container">
          <div className="banner-text">
            <h1 className="banner-title" id='titulli'>outsource to Shigjeta</h1>
            <p className="banner-description">
              Experience world-class outsourcing solutions from the heart of Kosovo. At Shigjeta, we combine top-tier expertise, cost efficiency, and a motivated workforce to help businesses scale effectively and achieve success.
            </p>
            <a href="#sec2" className="banner-button">Learn More About Outsourcing</a>
          </div>

        </div>
      </section>
      <div className='video-background'>
      <LazyLoad height={400} offset={100}>

      <video
              className="video"
              id='banner1-video'
              src="/video/ARROW OUTSOURCING.mp4"  // This should be correct if the video is in the public folder
              autoPlay
              muted
              loop
              playsInline
              onError={(e) => console.error('Error loading video:', e)}  // Error logging for debugging
            />

            </LazyLoad>
      </div>
      <section className="about-section">
  {/* Section 1: Why Outsource to Kaçanik, Kosovo */}
  <div className="about-row">
    <div className="about-text" id='sec2'>
      <h2><strong>Why in Kaçanik, Kosovo?</strong></h2>
      <p>
        Located strategically near major regional hubs like Skopje, Tetovo, Ferizaj and Prishtina the Kaçanik offers access to a young,
        talented, and eager workforce. Our cost-effective solutions paired with world-class quality make Kosovo
        an ideal outsourcing destination.
      </p>
      <ul>
        <p><strong>Geographic Advantage:</strong> Kacanik boasts lush valleys, cascading waterfalls, and dense forests, showcasing a remarkable display of untouched nature. </p>
        <p><strong>Youth Capacity:</strong> 45% of the population is under 30.</p>
        <p><strong>Work Ethic:</strong> Dedicated, resilient, and results-driven teams.</p>
      </ul>
     <a href='/CV' className="cta-button">Explore Our Workforce</a>
    </div>
    <div className="about-image">
      <img src="img/pg2.1.png" alt="Why in Kaçanik, Kosovo" />
    </div>
  </div>

  {/* Section 2: Our Talent Finding Program */}
  <div className="about-row reverse">
    <div className="about-text">
      <h2><strong>We are building the best talent for you</strong></h2>
      <p>
        Through our in-house programs like Shigjetademy and partnerships with local institutions, we nurture
        the next generation of skilled professionals. From developers to designers, our team is trained to meet
        global standards.
      </p>
      <ul>
        <p><strong>Training Programs:</strong> Focused on ICT, branding, and digital skills.</p>
        <p><strong>University Collaborations:</strong> Developing talent through education partnerships.</p>
        <p><strong>Scalability:</strong> Teams ready to grow with your business needs.</p>
      </ul>
      <a href='/ShigjetaAcademyForm' className="cta-button">Discover Talent Solutions</a>
    </div>
    <div className="about-image">
      <img src="img/pg2.2.png" alt="Our Talent Finding Program" />
    </div>
  </div>

  {/* Section 3: Work Ethics & Policies */}
  <div className="about-row">
    <div className="about-text">
      <h2><strong>Our Commitment to Excellence</strong></h2>
      <p>
        At Shigjeta, we implement innovative non-formal work policies to ensure quality and productivity. Our team
        benefits from a flexible work environment, allowing us to deliver consistent, high-quality results for our
        clients.
      </p>
      <ul>
        <p><strong>Four-Day Workweek:</strong> For enhanced productivity.</p>
        <p><strong>Flexible hours:</strong> To align with project demands.</p>
        <p><strong>Ethical policies:</strong> That foster team well-being and inclusivity.</p>
      </ul>
      <a href='/Jobapplication' className="cta-button">Do you want to work</a>
    </div>
    <div className="about-image">
      <img src="img/pg2.3.png" alt="Work Ethics & Policies" />
    </div>
  </div>

  {/* Section 4: Cost Efficiency */}
  <div className="about-row reverse">
    <div className="about-text">
      <h2><strong>Scalable, and Cost-Effective</strong></h2>
      <p>
        Whether your project is large or small, Shigjeta offers tailored outsourcing solutions designed to fit
        your budget. Our adaptive cost structures ensure you get maximum value without compromising on
        quality.
      </p>
      <ul>
        <p><strong>Dardanita:</strong> From €10k – to €100k</p>
        <p><strong>Ilirida:</strong> From €100k – to €1M</p>
        <p><strong>Arberita:</strong> From €1M – to €10M</p>
        <p><strong>Albanita:</strong> From €10M –  to €100M</p>
      </ul>
      <a href='/formular-contract' className="cta-button">Start Saving Today</a>
    </div>
    <div className="about-image">
      <img src="img/pg2.4.png" alt="Cost Efficiency" />
    </div>
  </div>

  {/* Section 5: Success Stories */}
  <div className="about-row">
    <div className="about-text">
      <h2><strong>We Deliver Results</strong></h2>
      <p>
        From startups to enterprises, our outsourcing solutions have empowered businesses to achieve
        growth, efficiency, and impact. Read our success stories to see how we deliver results.
      </p>
      <a href='/blog' className="cta-button">Read Success Stories</a>
    </div>
    <div className="about-image">
      <img src="img/pg2.5.png" alt="Success Stories" />
    </div>
  </div>
</section>
    </>
  );
}

export default Outsourcing;